import React from "react";

const NotFound = () => {
  const styles = {
    page: {
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #fff5f8, #ffffff, #ffeaf2)",
      padding: "20px",
      fontFamily: "Georgia, serif",
    },
    card: {
      width: "100%",
      maxWidth: "600px",
      textAlign: "center",
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      padding: "60px 40px",
      borderRadius: "30px",
      boxShadow: "0 20px 40px rgba(216, 50, 126, 0.15)",
      border: "1px solid rgba(216, 50, 126, 0.1)",
    },
    circleWrapper: {
      position: "relative",
      margin: "0 auto 40px auto",
      width: "160px",
      height: "160px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    glow: {
      position: "absolute",
      width: "160px",
      height: "160px",
      backgroundColor: "#D8327E",
      opacity: 0.2,
      borderRadius: "50%",
      filter: "blur(40px)",
    },
    circle: {
      position: "relative",
      width: "160px",
      height: "160px",
      borderRadius: "50%",
      border: "1px solid rgba(216, 50, 126, 0.3)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#ffffff",
      boxShadow: "inset 0 5px 15px rgba(0,0,0,0.05)",
    },
    code: {
      fontSize: "60px",
      fontWeight: "300",
      color: "#D8327E",
      letterSpacing: "5px",
    },
    heading: {
      fontSize: "42px",
      color: "#5B203B",
      marginBottom: "20px",
    },
    divider: {
      width: "70px",
      height: "4px",
      backgroundColor: "#D8327E",
      margin: "0 auto 25px auto",
      borderRadius: "5px",
    },
    quote: {
      fontSize: "18px",
      color: "rgba(91, 32, 59, 0.7)",
      fontStyle: "italic",
      lineHeight: "1.6",
      maxWidth: "400px",
      margin: "0 auto",
    },
    buttonContainer: {
      marginTop: "40px",
      display: "flex",
      flexDirection: "column",
      gap: "15px",
      alignItems: "center",
    },
    buttonOutline: {
      padding: "12px 30px",
      borderRadius: "50px",
      border: "1px solid #D8327E",
      backgroundColor: "transparent",
      color: "#D8327E",
      cursor: "pointer",
      fontSize: "16px",
      transition: "all 0.3s ease",
    },
    buttonFilled: {
      padding: "12px 30px",
      borderRadius: "50px",
      border: "none",
      backgroundColor: "#D8327E",
      color: "#ffffff",
      cursor: "pointer",
      fontSize: "16px",
      boxShadow: "0 10px 20px rgba(216, 50, 126, 0.3)",
      textDecoration: "none",
      display: "inline-block",
    },
    footer: {
      marginTop: "50px",
      fontSize: "12px",
      letterSpacing: "3px",
      textTransform: "uppercase",
      color: "rgba(91, 32, 59, 0.4)",
    },
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.circleWrapper}>
          <div style={styles.glow}></div>
          <div style={styles.circle}>
            <span style={styles.code}>404</span>
          </div>
        </div>

        <h1 style={styles.heading}>Page Not Found</h1>

        <div style={styles.divider}></div>

        <p style={styles.quote}>
          "True beauty is never lost, but this page definitely is."
        </p>

        <div style={styles.buttonContainer}>

          <a href="/" style={styles.buttonFilled}>
            Return Home
          </a>
        </div>

        <p style={styles.footer}>Cherry-K Health & Beauty Center</p>
      </div>
    </div>
  );
};

export default NotFound;
